import React from 'react';

interface PhoneTypes {
  ddd: string;
  telefone: string;
  ramal: string;
}

interface PhoneCardProps {
  phones: Array<PhoneTypes>;
}

const PhoneCard = (props: PhoneCardProps) => {
  const { phones } = props;

  return (
    <>
      {phones.map((phone: PhoneTypes) => (
        <div key={`phone_(${phone.ddd})${phone.telefone}${phone.ramal}`} className="row">
          <div className="col-md-12">
            {`(${phone.ddd}) ${phone.telefone}`} {phone.ramal !== '' && `- Ramal: ${phone.ramal}`}
          </div>
        </div>
      ))}
    </>
  );
};

export default PhoneCard;
